var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ui-create-task-modal',{attrs:{"name":"global-deals-create-task","customer-change-option":"","show-close-option":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }